import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SeverityLevelContact } from '../../data/severity-level-contacts';

@Component({
  selector: 'app-severity-level-contacts-grid',
  templateUrl: './severity-level-contacts-grid.component.html',
  imports: [MatIconModule, RouterModule, MatTooltipModule],
})
export class SeverityLevelContactsGridComponent {
  @Input() severityLevelContacts: SeverityLevelContact[] = [];

  public severityLevelContactRowSpan(
    severityLevelContact: SeverityLevelContact,
  ): number {
    return (
      severityLevelContact.contacts.length +
      ('generalEmail' in severityLevelContact &&
      severityLevelContact.generalEmail !== undefined
        ? 1
        : 0)
    );
  }
}
